import { actionTypes } from "../actions/action_types";

const initialState = {
  Config: {
    title: "add title",
    isModalOpen: false,
    currentComponent: null,
    size: "md",
    custom: false,
  },
};

export default function modalReducer(state = initialState, action) {
  var stateCopy = Object.assign({}, state);

  switch (action.type) {
    case actionTypes.MAIN_MODAL_OPEN:
      if (action.payload.onEntering != null) {
        action.payload.onEntering();
      }
      stateCopy.Config.title = action.payload.title;
      stateCopy.Config.currentComponent = action.payload.currentComponent;
      stateCopy.Config.isModalOpen = true;
      stateCopy.Config.custom = action.payload.custom;
      stateCopy.Config.size = !action.payload.size ? "md" : action.payload.size;
      return stateCopy;

    case actionTypes.MAIN_MODAL_CLOSE:
      stateCopy.Config.isModalOpen = action.payload;
      return stateCopy;

    default:
      return state;
  }
}
